import { aunjaiSourceCodeClient } from "../lib/axios";

export class AunjaiScService {
  constructor(_aunjaiSourceCodeClient) {
    this._aunjaiSourceCodeClient = _aunjaiSourceCodeClient;
  }

  async insertAttachment(formData) {
    await aunjaiSourceCodeClient.post("/api/aunjai/attachment", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  async updateCustomer(formData) {
    await aunjaiSourceCodeClient.post("/api/aunjai/updateCustomer", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export const aunjaiScService = new AunjaiScService(aunjaiSourceCodeClient);
